import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import * as React from 'react';

import { DefaultSnackbarProviderProps } from '../components/Snackbar';
import { TestI18nProvider } from './TestI18nProvider';
import { testTheme } from './testTheme';

/** The providers a component needs, without a router: `withStoryRouter` and `renderWithRouter` mount one. */
export const TestProviders: React.FC<{ children: React.ReactNode }> = ({ children }) =>
    (
        <TestI18nProvider>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={testTheme}>
                    <CssBaseline />
                    <SnackbarProvider {...DefaultSnackbarProviderProps}>{children}</SnackbarProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        </TestI18nProvider>
    ) as any;
